/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

export enum DIR {
	LTR = "ltr",
	RTL = "rtl",
}

export type Direction = "ltr" | "rtl";

const RTL_LANG_CODES = ["ar", "ar-ar", "ar-AR"];

export const isLangRtl = (locale: string): boolean => {
	if (!locale || typeof locale !== "string") return false;
	return RTL_LANG_CODES.includes(locale);
};

export const getDirection = (locale: string): Direction => {
	const isRtl = isLangRtl(locale);
	return isRtl ? "rtl" : "ltr";
};
